import type { DeliverableTile, Step } from "../../../api/types";
import { elementKindPhrase } from "../../../ui/words";

/** The word for a kind of element inside a sentence ("an item", "2 sub-families"): the shared word, in lower case. */
export function kindWord(kind: string): string {
  return elementKindPhrase(kind);
}

/** The steps of a session, as the trail names them. */
export const STEP_WORDS: Record<Step, string> = {
  goal_and_item: "goal and item",
  plan: "plan",
  read: "read",
  match: "match",
  fill: "fill",
  checks: "checks",
  hand_over: "hand-over",
};

/** The address of the family navigator with one node chosen. */
export function navigatorHref(id: string): string {
  return `/navigate?select=${encodeURIComponent(id)}`;
}

/** The first name of a person, for a greeting. */
export function firstName(displayName: string): string {
  return displayName.trim().split(/\s+/)[0] ?? displayName;
}

/** What a document tile says about where its kind of document comes from: the starter pack (on the target list or not) or the team. */
export function tileNote(tile: Pick<DeliverableTile, "origin" | "on_target_list">): string {
  if (tile.origin === "work") return "Added by your team";
  return tile.on_target_list ? "On the target list" : "Loaded, not on the target list";
}
